import { useEntityQuery } from 'src/hooks/use-entity-query';

import { endpoints } from 'src/utils/axios';

import { queryKeys } from 'src/react-query/constants';

import { IContentCategory } from 'src/types/agency';

export function useGetContentCategories(options?: { enabled?: boolean }) {
  const { data, isLoading, isFetching, isError } = useEntityQuery<IContentCategory>({
    queryKey: [queryKeys.contentCategories],
    endpoint: endpoints.agency.contentCategories,
    enabled: options?.enabled,
    staleTime: Infinity,
    gcTime: 30000,
  });

  return { contentCategories: data?.value || [], isLoading, isFetching, isError };
}
